var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWrong(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 130,
    viewBox: "0 0 130 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M130 65C130 100.899 100.899 130 65 130C29.1015 130 0 100.899 0 65C0 29.1015 29.1015 0 65 0C100.899 0 130 29.1015 130 65Z",
    fill: "url(#paint0_linear_263_110)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8391 50.4017V35C58.8391 32.7909 60.6299 31 62.8391 31H67.1609C69.3701 31 71.1609 32.7909 71.1609 35V50.4017L70.2271 71.4433C70.1322 73.5813 68.3712 75.2659 66.231 75.2659H63.769C61.6288 75.2659 59.8678 73.5813 59.7729 71.4433L58.8391 50.4017ZM65 99C62.7931 99 60.8927 98.2151 59.2989 96.6454C57.7663 95.0129 57 93.0665 57 90.8061C57 88.5457 57.7663 86.6307 59.2989 85.0609C60.8927 83.4912 62.7931 82.7064 65 82.7064C67.2069 82.7064 69.0766 83.4912 70.6092 85.0609C72.2031 86.6307 73 88.5457 73 90.8061C73 93.0665 72.2031 95.0129 70.6092 96.6454C69.0766 98.2151 67.2069 99 65 99Z",
    fill: "#14022E"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_263_110",
    x1: 130,
    y1: 130,
    x2: -110.543,
    y2: 57.9843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#650BE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B071E7"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrong);
export default __webpack_public_path__ + "static/media/wrong.ec98e0e0a91e964215633b8670253e7a.svg";
export { ForwardRef as ReactComponent };